import axios from "axios";
import { getAuthToken } from "common-ui-components/accounts/framework/AuthTokenHandler";
import { redirectToSignIn } from "app/root/Root";
import {
    IAM_FRONT_END_URL,
    PATCHMANAGEMENT_API_URL,
    PRODUCT_CONTEXT,
    PRODUCT_ID,
} from "common-ui-components/components/utils/Config";

/**
 * Axios instance configured for PATCH API requests
 * @type {import('axios').AxiosInstance}
 * @description Creates an HTTP client with:
 * - Base URL from Patch_API_URL environment variable
 * - JSON content type and accept headers
 * - Credentials included in requests (withCredentials)
 */
const Patch_API = axios.create({
  baseURL: PATCHMANAGEMENT_API_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
  withCredentials: true,
});

Patch_API.interceptors.request.use(
  (config) => {
    config.metadata = { startTime: new Date() };
    const token = getAuthToken();
    //us the below given for hardcoded token
    // const token="b8-c8olZQB7k7dg9lUE1518Ax9ig7lunhvqK_ZKbw8w"
    if (token) config.headers["Authorization"] = `Bearer ${token}`;
    else delete config.headers["Authorization"];

    config.params = {
      ...config.params,
      productId: PRODUCT_ID,
    };
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);
let isRedirectingToTryProduct = false;

// Handle responses and errors globally
Patch_API.interceptors.response.use(
  (response) => {
    response.config.metadata.endTime = new Date();
    response.duration =
      response.config.metadata.endTime - response.config.metadata.startTime;
    //console.log(`Path ${response.config.url} taken ${response.duration}ms`);
    const content_header = response.headers["content-disposition"];
    if (content_header) {
      return response;
    }
    return response.data;
  },
  (error) => {
    const { response } = error;

    if (!response) {
      console.error("Network error or no response:", error);
      return Promise.reject(error);
    }

    switch (response.status) {
      case 307:
        window.location.href = response.data.redirectUrl;
        break;
      case 406:
        const pathname = window.location.pathname;
        const base = pathname.startsWith("/am") ? "/am" : "/em";
        window.location.href = `${base}/try-product`;
        break;
      case 401:
        if (!isRedirectingToTryProduct) {
          isRedirectingToTryProduct = true;
          redirectToSignIn();
        }
        break;
      case 423:
        window.location.href = `${IAM_FRONT_END_URL}/auth/waitingForApproval?product=${PRODUCT_CONTEXT}`;
        break;
      default:
        console.error(error);
    }
    return Promise.reject(error);
  },
);

export default Patch_API;
